import React from 'react';

import Breadcrumb, { DataType } from '../../../components/Breadcrumb';

import styles from './Banner.module.scss';

interface IProps {
  breadcrumb: DataType[];
}

function Banner(props: IProps) {
  const { breadcrumb } = props;

  return (
    <div className={styles.container}>
      <Breadcrumb
        data={breadcrumb}
        className="w-full lg:m-auto lg:max-w-screen-xl xl:max-w-[1280px] xl:max-w-screen-2xl"
      />
    </div>
  );
}

export default Banner;
